import api from './axiosConfig';

export interface FetchHVACallsPerHourandCampaignParams {
  campaign?: string;
}

export interface FetchHVACallingTodaySuccessParams {
  campaign?: number;
  interval: number;
}

export interface FetchHVACallingTodayKPIsParams {
  campaign?: number;
}

export interface FetchHVACallRecordingParams {
  campaign: number;
  callfilepath: string;
}

export const opencloseCampaign = async (campaignid: number, action: string) => {
  try {
    const response = await api.get(`/hvacampaigns/${campaignid}/${action}`);
    return response.data;
  } catch (error) {
    console.error('Failed to update campaign:', error);
    throw error;
  }
};

export const fetchHVACallsPerHourandCampaign = async (
  params: FetchHVACallsPerHourandCampaignParams
) => {
  try {
    const response = await api.post('/hvacalls/todaycallsperhour', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA outbound today`s calls:', error);
    throw error;
  }
};

export const fetchHVACallsPerHourandCampaignInbound = async (
  params: FetchHVACallsPerHourandCampaignParams
) => {
  try {
    const response = await api.post(
      '/hvacalls/todaycallsperhourinbound',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA inboundtoday`s calls:', error);
    throw error;
  }
};

export const fetchHVACallingTodaySuccess = async (
  params: FetchHVACallingTodaySuccessParams
) => {
  try {
    const response = await api.post('/hvacalls/todaycallingsuccess', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s calling success:', error);
    throw error;
  }
};

export const fetchHVACallingTodaySuccessInbound = async (
  params: FetchHVACallingTodaySuccessParams
) => {
  try {
    const response = await api.post(
      '/hvacalls/todaycallingsuccessinbound',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s calling success:', error);
    throw error;
  }
};

export const fetchHVACallingTodayKPIs = async (
  params: FetchHVACallingTodayKPIsParams
) => {
  try {
    const response = await api.post('/hvacalls/todaycallskpis', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s calling KPIs:', error);
    throw error;
  }
};

export const fetchHVACallingTodayKPIsInbound = async (
  params: FetchHVACallingTodayKPIsParams
) => {
  try {
    const response = await api.post('/hvacalls/todaycallskpisinbound', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s calling KPIs:', error);
    throw error;
  }
};

export const fetchHVACampaignTodayFunnel = async (campaignid: number) => {
  try {
    const response = await api.get(
      `/hvacalls/todaycampaignfunnel/${campaignid}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s campaign funnel: ', error);
    throw error;
  }
};

export const fetchHVACampaignTodayFunnelInbound = async (
  campaignid: number
) => {
  try {
    const response = await api.get(
      `/hvacalls/todaycampaignfunnelinbound/${campaignid}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA today`s campaign funnel: ', error);
    throw error;
  }
};

export const fetchHVACampaignWorkloadEvolution = async (campaignid: number) => {
  try {
    const response = await api.get(
      `/hvacalls/campaignworkloadevolution/${campaignid}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA campaign workload: ', error);
    throw error;
  }
};

export const FetchHVACallRecording = async (
  params: FetchHVACallRecordingParams
) => {
  try {
    const response = await api.post('/hvacalls/callrecording', params, {
      responseType: 'blob' // Importante para manejar el audio como blob
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Call Recording: ', error);
    throw error;
  }
};
